import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <IndexSection />
        <CommentsSection />
        <ContactSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <TopicsSection />
        <MediaSection />
        <CardsSection />
        <FaqSection />
        <AppSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}